module.exports = __webpack_public_path__ + "img/20190725161801QQ截图20190725005957.6e9f12b3.png";